export default ({
  palette, alerts
}) => ({

  root: {
    position: 'relative',
    display: 'flex',
    marginBottom: 24,
    ...alerts.wrap,

    '& button': {
      background: 'none',
      border: 'none',
      padding: 0,
      display: 'inherit'
    },
    '& svg': {
      fill: palette.accent
    }
  },
  alertIcon: {
    ...alerts.alertIcon
  },
  btnDetails: {
    ...alerts.btnDetails,
    '&:focus': {
      outlineColor: alerts.focusColor
    }
  },
  labelDetails: {
    ...alerts.labelDetails
  },
  IconDetails: {
    ...alerts.IconDetails
  },
  close: {
    height: 16,
    alignSelf: 'flex-start',
    ...alerts.closeButton,
    '&:focus': {
      outlineColor: alerts.focusColor
    }
  },
  alertDetails: {
    flexGrow: 1,
    ...alerts.alertDetails
  },
  alertDetailsContent: {
    marginBottom: 10
  },
  alertTitle: {
    fontSize: 16,
    ...alerts.alertTitle
  },
  titleWithMessage: {
    marginBottom: 10
  },
  alertMessage: {
    ...alerts.alertMessage
  },
  primary: {
    ...alerts.positive
  },
  secondary: {
    ...alerts.positive
  },
  info: {
    ...alerts.info
  },
  success: {
    ...alerts.positive
  },
  warning: {
    ...alerts.warning
  },
  error: {
    ...alerts.negative
  }
});
